// Petites cartes : la semaine de l'accueil de l'app, la notification de
// programmation, la notification de fiche Gym'Coach.
import React from "react";
import Apercu from "./Apercu";
import iconeApp from "../../images/favicon.png";

// Le widget « Ma semaine » de l'accueil de l'app (screens/home/WeekDots.js,
// thème sombre) : une pastille par jour, teal les jours avec au moins une
// séance, aujourd'hui cerclé. Les pastilles se remplissent à l'apparition.
const JOURS_SEMAINE = ["L", "M", "M", "J", "V", "S", "D"];
const SEMAINE = [true, false, true, false, true, false, false];
const AUJOURDHUI = 4;

export function ApercuSemaine({ className = "", boucle = false }) {
	let rang = 0;
	return (
		<Apercu
			boucle={boucle}
			className={className}
			description="Widget « Ma semaine » de l'app : séances lundi, mercredi et vendredi, aujourd'hui."
		>
			<div className="gs-sem">
				<div className="gs-sem-titre">Ma semaine</div>
				<div className="gs-sem-jours">
					{JOURS_SEMAINE.map((j, i) => (
						<span key={i} className={`gs-sem-jour${i === AUJOURDHUI ? " gs-sem-jour--auj" : ""}`}>
							<span className="gs-sem-lettre">{j}</span>
							<span className="gs-sem-point">
								{SEMAINE[i] && <i className="gs-a-plein" style={{ "--i": rang++ }} />}
							</span>
						</span>
					))}
				</div>
			</div>
		</Apercu>
	);
}

// La notification push que l'élève reçoit quand son coach lui programme des
// séances, texte repris tel quel de l'API (GymNoteController, « programmation »).
export function ApercuNotificationProgrammation({ className = "", sombre = false }) {
	const texte = "Hugo vous a programmé 4 séance(s) : PPL 4 semaines";
	return (
		<Apercu className={className} description={`Notification GymNote : ${texte}.`}>
			<div className={`gs-a-carte${sombre ? " gs-a-carte--sombre" : ""}`}>
				<div className="gs-a-ligne">
					<img src={iconeApp} alt="" className="gs-a-banniere-icone" />
					<div style={{ minWidth: 0, flex: 1 }}>
						<div className="gs-a-banniere-haut">
							<span>GymNote</span>
							<span>maintenant</span>
						</div>
						<div className="gs-a-titre">{texte}</div>
					</div>
				</div>
			</div>
		</Apercu>
	);
}

// La notification telle que l'élève la reçoit sur son téléphone : une bannière
// qui glisse en place une fois visible.
// La notification que l'élève trouve dans l'app quand son coach personnalise
// la fiche Gym'Coach d'une séance. Notification interne, jamais push (API :
// GymNoteController, « coach_preview ») : reproduite telle que la liste des
// notifications l'affiche (screens/home/NotificationHistoryModal.js, thème
// sombre, non lue), texte au format de l'API.
const SIFFLET =
	"M8.48 9Q6.75 9 5.25 9.87Q3.75 10.73 2.88 12.23Q2.02 13.73 2.02 15.49Q2.02 17.25 2.88 18.75Q3.75 20.25 5.25 21.12Q6.75 21.98 8.51 21.98Q10.27 21.98 11.77 21.12Q13.27 20.25 14.13 18.75Q15 17.25 15 15.52V13.92L21.98 12V9H11.02V11.02H9V9ZM11.02 2.02V6.98H9V2.02ZM6.33 7.27Q5.34 7.5 4.45 8.02L2.16 4.88L3.75 3.7ZM17.86 4.88 16.31 6.98H13.83L16.22 3.7Z";

export function ApercuNotificationFiche({ className = "" }) {
	const texte = "Hugo a personnalisé la fiche de ta séance «\u00a0Pull\u00a0»";
	return (
		<Apercu className={className} description={`Notification dans l'app de l'élève : Fiche Gym'Coach, ${texte}.`}>
			<div className="gs-nf gs-anim-glisse">
				<span className="gs-nf-icone">
					<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
						<path d={SIFFLET} fill="#30a49a" />
					</svg>
				</span>
				<div className="gs-nf-corps">
					<div className="gs-nf-haut">
						<span className="gs-nf-titre">Fiche Gym'Coach</span>
						<span className="gs-nf-point" />
					</div>
					<div className="gs-nf-texte">{texte}</div>
					<div className="gs-nf-date">À l'instant</div>
				</div>
			</div>
		</Apercu>
	);
}
